<template>
  <b-modal
    title="ایجاد تخفیف جدید"
    id="modal-discount-add"
    no-close-on-backdrop
    centered
    ok-title="ایجاد"
    cancel-title="انصراف"
    @cancel="closeModal"
    @ok.prevent="sendDiscountCreateRequest"
  >
    <b-container fluid>
      <b-form-row>
        <b-col cols="12" md="6">
          <b-form-group
            label="نوع تخفیف را انتخاب کنید"
            label-for="discount-type"
          >
            <b-form-select
              size="sm"
              id="discount-type"
              :options="discountTypes"
              v-model="discountDetails.type"
              placeholder="نوع تخفیف"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group :label="discountValueLabel" label-for="discount-type">
            <b-form-input
              size="sm"
              id="discount-type"
              v-model="discountDetails.value"
              :placeholder="discountValuePlaceholder"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ شروع تخفیف" label-for="discountStart">
            <b-form-input
              class="startDate"
              size="sm"
              id="discountStart"
              placeholder="تاریخ شروع تخفیف را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="discountDetails.startDate"
              class="absolute"
              customInput=".startDate"
              display-format="jYYYY/jMM/jDD"
              input-format="jYYYY/jMM/jDD"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="تاریخ اتمام تخفیف" label-for="discountExpire">
            <b-form-input
              class="expireDate"
              size="sm"
              id="discountExpire"
              placeholder="تاریخ اتمام تخفیف را وارد کنید"
            ></b-form-input>
            <date-picker
              v-model="discountDetails.expireDate"
              class="absolute"
              customInput=".expireDate"
              display-format="jYYYY/jMM/jDD"
              input-format="jYYYY/jMM/jDD"
              format="YYYY-MM-DD"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col :cols="isLessonDiscount ? 6 : 12">
          <course-picker @getCourse="setCourseId"></course-picker>
        </b-col>
        <b-col cols="6" v-if="isLessonDiscount">
          <lesson-picker
            :isDisabled="!tempCourseId"
            :defaultCourseId="tempCourseId"
            @getLesson="setLessonId"
          ></lesson-picker>
        </b-col>
      </b-form-row>
    </b-container>
  </b-modal>
</template>
<script>
import CoursePicker from "../MasterActiveCourse/CoursePicker.vue";
import LessonPicker from "../Lessons/LessonPicker.vue";
import { CreateDiscount } from "@/libs/Api/Discount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
export default {
  emits: ["reFetch"],
  props: {
    discountFor: {
      type: String,
      default: "course",
      validator(value) {
        // The value must match one of these strings
        return ["course", "lesson"].includes(value);
      },
    },
  },
  data() {
    return {
      discountTypes: [
        {
          text: "تخفیف درصدی",
          value: 2,
        },
        {
          text: "تخفیف عددی",
          value: 1,
        },
      ],
      discountDetails: {
        // Types: {
        //    1: ByDigit,
        //    2: ByPercentage
        // }
        expireDate: null,
        type: 1,
        value: null,
        refraction: true,
        courseId: null,
        lessonId: null,
        startDate: new Date(Date.now()),
      },
      tempCourseId: null,
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-discount-add");
    },
    setLessonId(lessonId) {
      this.discountDetails.lessonId = lessonId;
    },
    setCourseId(courseId) {
      this.tempCourseId = courseId;
      if (!this.isLessonDiscount) {
        this.discountDetails.courseId = courseId;
      }
    },
    async sendDiscountCreateRequest() {
      try {
        this.discountDetails.startDate = new Date(
          this.discountDetails.startDate
        );
        if (this.discountDetails.expireDate) {
          this.discountDetails.expireDate = new Date(
            this.discountDetails.expireDate
          );
        }
        let _this = this;
        let createDiscount = new CreateDiscount(_this);
        createDiscount.setRequestParamDataObj(_this.discountDetails);
        await createDiscount.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تخفیف با موفقیت ایجاد شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.$emit("reFetch");
            _this.closeModal();
          }
        });
      } catch (error) {
        // console.error(error.response);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "این دوره در تاریخ انتخابی یک تخفیف فعال دارد",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
  computed: {
    discountValueLabel() {
      if (this.discountDetails.type == 1) {
        return "مقدار تخفیف (تومان)";
      } else if (this.discountDetails.type == 2) {
        return "مقدار تخفیف (درصد)";
      }
    },
    discountValuePlaceholder() {
      if (this.discountDetails.type == 1) {
        return "مقدار تخفیف را به تومان وارد کنید";
      } else if (this.discountDetails.type == 2) {
        return "مقدار درصد تخفیف را وارد کنید";
      }
    },
    isLessonDiscount() {
      if (this.discountFor == "lesson") {
        return true;
      }
      return false;
    },
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BFormSelect,
    CoursePicker,
    LessonPicker,
  },
};
</script>
